/**
 * 특정 국가에서 정렬 순서가 다를 때 
 * - countryItem: {name: string(국가명), index: number} // 단, 해당 국가가 포함된 모든 게임들은 {name: string, index: number} 로 지정해야함
 * 
 * 국가별 정렬 순서 동일 
 * - countryItem: string
 * 
 * 특정 국가에서 l10nKey값이 다를 때
 * - countryItem: {name: string(국가명), l10nKey: string}
 */

import { AREA_TYPE, COUNTRY_CODE } from './index';

export const GAME = {
    TL: 'tl',
    LW: 'lineagew',
    BNS2: 'bns2',
    TRICKSTERM: 'tricksterm',
    H3: 'h3',
    L2M: 'lineage2m',
    L2MNU: 'lineage2mnaeu',
    L2MRU: 'lineage2mru',
    LM: 'lineagem',
    H2: 'h2',
    BNS: 'bns',
    AION: 'aion',
    LOVEBEAT: 'lovebeat',
    L2: 'lineage2',
    LINEAGE: 'lineage',
    JMM: '雀龍門M',
    JIN_JANRYUMON: '真_雀龍門'
};

const CC = COUNTRY_CODE;
export const NCK_GAMES = [
    {
        name: [GAME.TL],
        l10nKey: 'tl',
        app: 'pc',
        url: 'https://tl.plaync.com',
        urlRc: 'https://rc-tl.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.LW],
        l10nKey: 'lineagew',
        app: 'pc,apple,android',
        url: 'https://lineagew.plaync.com',
        urlRc: 'https://rc-lineagew.plaync.com',
        country: [CC.KR, CC.NC, {name: CC.TW, index: 1}, {name: CC.JP, index: 1}, CC.ID, 
            CC.TH, CC.MY, CC.SA, CC.AE, CC.QA, 
            CC.HK, CC.SG, CC.PH]
    },
    {
        name: [GAME.BNS2],
        l10nKey: 'bns2',
        app: 'pc,apple,android',
        url: 'https://bns2.plaync.com',
        urlRc: 'https://rc-bns2.plaync.com',
        country: [CC.KR, CC.NC, {name: CC.JP, index: 0, l10nKey: 'BnS2'}, {name: CC.TW, index: 0, l10nKey: 'BnS2'}],
    },
    {
        name: [GAME.TRICKSTERM],
        l10nKey: 'tricksterm',
        app: 'pc,apple,android',
        url: 'https://tricksterm.plaync.com',
        urlRc: 'https://rc-tricksterm.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.H3],
        l10nKey: 'h3',
        app: 'pc,apple,android',
        url: 'https://h3.plaync.com',
        urlRc: 'https://rc-h3.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com',
        urlRc: 'https://rc-lineage2m.plaync.com',
        country: [CC.KR, CC.NC, CC.RU, CC.AE, CC.US, 
            CC.CA, CC.DE, CC.GB, CC.FR, CC.BR, 
            CC.IT, CC.ES, CC.CL, CC.NO, CC.SE, 
            CC.IE, CC.PT, CC.FI, CC.DK, CC.CH,
            CC.AR, CC.PE, CC.MX, CC.KZ, CC.UZ, 
            CC.AZ, CC.GE, CC.MD, CC.AM, CC.UA,
            CC.PL, CC.GR, CC.BY, CC.LT, CC.IL, 
            CC.KW, CC.AT]
    },
    {
        name: [GAME.L2MNU],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com',
        urlRc: 'https://rc-lineage2m.plaync.com',
        country: []
    },
    {
        name: [GAME.L2MRU],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com',
        urlRc: 'https://rc-lineage2m.plaync.com',
        country: []
    },
    {
        name: [GAME.LM],
        l10nKey: 'lineagem',
        app: 'pc,apple,android',
        url: 'https://lineagem.plaync.com',
        urlRc: 'https://rc-lineagem.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.H2],
        l10nKey: 'h2',
        app: 'apple,android',
        url: 'https://h2.plaync.com',
        urlRc: 'https://rc-h2.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.BNS],
        l10nKey: 'bns',
        app: 'pc',
        url: 'https://bns.plaync.com',
        urlRc: 'https://rc-bns.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.AION],
        l10nKey: 'aion',
        app: 'pc',
        url: 'https://aion.plaync.com',
        urlRc: 'https://rc-aion.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.LOVEBEAT],
        l10nKey: 'lovebeat',
        app: 'pc',
        url: 'https://lovebeat.plaync.com',
        urlRc: 'https://rc-lovebeat.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.L2],
        l10nKey: 'lineage2',
        app: 'pc',
        url: 'https://lineage2.plaync.com',
        urlRc: 'https://rc-lineage2.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.LINEAGE],
        l10nKey: 'lineage',
        app: 'pc',
        url: 'https://lineage.plaync.com',
        urlRc: 'https://rc-lineage.plaync.com',
        country: [CC.KR, CC.NC]
    }
];

export const NCT_GAMES = [
    {
        name: [GAME.BNS2],
        l10nKey: 'BnS2',
        app: 'pc,apple,android',
        url: 'https://bns2.plaync.com/',
        urlRc: 'https://rc-bns2.plaync.com/',
        country: [],
    },
    {
        name: [GAME.LW],
        l10nKey: 'lineagew',
        app: 'pc,apple,android',
        url: 'https://lineagew.plaync.com/tw/index',
        urlRc: 'https://rc-lineagew.plaync.com/tw/index',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://tw.ncsoft.com/lineage2m/',
        urlRc: 'https://rc-tw.ncsoft.com/lineage2m/',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'NCTBns',
        app: 'pc',
        url: 'https://tw.ncsoft.com/bns/index',
        urlRc: 'https://rc-tw.ncsoft.com/bns/index',
        country: []
    },
    {
        name: [GAME.AION],
        l10nKey: 'NCTAion',
        app: 'pc',
        url: 'https://tw.ncsoft.com/aion/',
        urlRc: 'https://rc-tw.ncsoft.com/aion/',
        country: []
    },
    {
        name: [GAME.L2],
        l10nKey: 'NCTLineage2',
        app: 'pc',
        url: 'https://tw.ncsoft.com/lineage2/',
        urlRc: 'https://rc-tw.ncsoft.com/lineage2/',
        country: []
    }
];

export const NCJ_GAMES = [
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.ncsoft.jp/',
        country: []
    },
    {
        name: [GAME.JMM],
        l10nKey: 'NCJJmm',
        app: 'apple,android',
        url: 'https://jmm.ncsoft.jp/',
        country: []
    },
    {
        name: [GAME.LM],
        l10nKey: 'lineagem',
        app: 'apple,android',
        url: 'https://lineagem-jp.com/',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'BnS',
        app: 'pc',
        url: 'https://www.ncsoft.jp/bns/',
        country: []
    },
    {
        name: [GAME.AION],
        l10nKey: 'AION',
        app: 'pc',
        url: 'https://www.ncsoft.jp/aion/',
        country: []
    },
    {
        name: [GAME.L2],
        l10nKey: 'NCJLineage2',
        app: 'pc',
        url: 'https://www.ncsoft.jp/lineage2/',
        country: []
    },
    {
        name: [GAME.LINEAGE],
        l10nKey: 'lineage',
        app: 'pc',
        url: 'https://www.ncsoft.jp/lineage/',
        country: []
    },
    {
        name: [GAME.JIN_JANRYUMON],
        l10nKey: 'NCJJanryumon',
        app: 'pc',
        url: 'https://www.ncsoft.jp/janryumon/',
        country: []
    }
];

export const GAME_AREA_MAP = {
    [AREA_TYPE.NCK]: NCK_GAMES,
    [AREA_TYPE.NCT]: NCT_GAMES,
    [AREA_TYPE.NCJ]: NCJ_GAMES
};
